import { Dialog, InputV2 } from '@cimplico/components';
import { useState } from 'react';
import { toastNotification } from '../../components/toast/Toast';
import { useCreateLinks } from '../../queries/use-create-links';
import { useIntercom } from 'react-use-intercom';

type NewLinkDialogProps = {
    parentFolderId?: string;
    onCreate: (newLinkId?: string) => void;
    onClose: () => void;
};

function NewLinkDialog({ onClose, onCreate, parentFolderId }: NewLinkDialogProps): JSX.Element {
    const [link, setLink] = useState('');
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState('');
    const [linkError, setLinkError] = useState('');
    const createLinksQuery = useCreateLinks();
    const expression = '^(http|https)://';
    const re = new RegExp(expression);

    function createLink(e?: React.FormEvent<HTMLFormElement>): void {
        if (e) {
            e.preventDefault();
        }
        if (!name) {
            setNameError('A name is required!');
        }

        if (!link) {
            setLinkError('A link is required!');
        } else if (re.test(link) === false) {
            setLinkError('Links must start with http:// or https:// .');
            toastNotification('error', 'Unable to create link!');
            return;
        }

        if (!name || !link) {
            toastNotification('error', 'Unable to create link!');
            return;
        }

        createLinksQuery.mutate([{ parentFolderId, name, link }], {
            onSuccess: ({ results }) => {
                onCreate(results[0].data?.id);
                toastNotification('success', 'New link created!');
            },
            onError: (err) => {
                setNameError(err.response?.data.results[0].error.fields.name);
                toastNotification('error', 'Unable to create new link!');
            },
        });
    }

    function handleNameChange(val: string): void {
        setNameError('');
        setName(val);
    }

    function handleLinkChange(val: string): void {
        setLinkError('');
        setLink(val);
    }

    return (
        <Dialog
            onClose={onClose}
            description="Do you want to create a new link record? Links can sometimes break, therefore, we recommend uploading the actual document to ensure it is always available."
            isOpen={true}
            primaryAction="Create Link"
            secondaryAction="Cancel"
            title="Create a new Link"
            type="success"
            onPrimaryActionClick={createLink}
            onSecondaryActionClick={onClose}
            isLoading={createLinksQuery.isLoading}
        >
            <form onSubmit={createLink} id="link-form">
                <div className="pr-6 pb-4">
                    <InputV2
                        type="text"
                        placeholder="Link name"
                        title="Name"
                        onChange={handleNameChange}
                        errorMessage={nameError}
                        form="link-form"
                        autoFocus
                    />
                    <div className="mt-4">
                        <InputV2
                            type="text"
                            placeholder="https://example.website.com"
                            title="Link"
                            onChange={handleLinkChange}
                            errorMessage={linkError}
                        />
                    </div>
                </div>
                <button className="hidden" />
            </form>
        </Dialog>
    );
}
export default NewLinkDialog;
